import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import { setOptionChainAction } from '../../actions/optionChainAction';
import AdvancedBoard from './AdvancedBoard';
import BasicCallBoard from './BasicCallBoard';
import BasicPutBoard from './BasicPutBoard';
import StrikeNear from './StrikeNear';
import styles from './OptionsBoardStyles';

import { setAppStateAction } from '../../actions/appStateAction';
import {
	checkStatusFunc,
	fetchDataFunc,
	jsonifyFunc,
	makeReStructuredRows,
	parseJSONFunc,
} from '../../Shared';
import moment from 'moment';
import { BaseURL } from '../../constants';
import { createWarningsListFunc } from '../../Shared/addWarnings';

const BoardViewSection = ({ rows, changeBidAskMid }) => {
	const { appReducer, optionChainReducer } = useSelector((state) => state);
	const dispatch = useDispatch();

	const {
		isMobile,
		width,
		expiration,
		refreshingData,
		refreshingQuote,
		targetPrice,
		confidence,
		selections,
		expirationOptions,
		shadingActive,
		quoteInfo: { latestPrice },
		accessLevel,
		modalDetail,
		ticker,
		data,
		modalDetail2,
		modalDetail3,
		quoteInfo,
	} = appReducer;

	const {
		watchListModalIndex,
		localTicker,
		selectedDate,
		zoompercent,
		strikeValue,
		checkPut,
		check,
		nearValue,
		showAdvancedBoard,
		strikeWidth,
		hideShading,
		bidAskMid,
		modalDate,
		favioute,
		backFromAdvance,
	} = optionChainReducer;

	const [state, setState] = useState({
		callsAnswerArrowPos: confidence / 10,
		putsAnswerArrowPos: confidence / 10,
		currentPriceArrowPos: { rowPos: undefined, value: undefined },
		noOMS: true,
		highestCallEdge: { rowIndex: 0, value: 0 },
		highestCallActual: { rowIndex: 0, value: 0 },
		highestPutEdge: { rowIndex: 0, value: 0 },
		highestPutActual: { rowIndex: 0, value: 0 },
		answerArrowPos: confidence / 10,
		callRows: [],
		putRows: [],
	});
	const [warningsState, setWarningsState] = useState([]);
	const setAppState = (payload) => dispatch(setAppStateAction(payload));
	const setOptionChainState = (payload) =>
		dispatch(setOptionChainAction(payload));

	const toggleShading = () => {
		setOptionChainState({
			hideShading: !hideShading,
		});
		ReactGA.event({
			category: 'ChainAction',
			action: 'Toggle Shading',
			label: `${!hideShading}`,
		});
	};

	const changeExpiration = (expiration, date = '') => {
		if (expiration === 'placeholder') return;
		setAppState({ expiration });
		fetchDataFunc(ticker, expiration, date, appReducer, setAppState);
		ReactGA.event({
			category: 'ChainAction',
			action: 'Changed expiration',
			label: `${ticker} by ${expiration}`,
		});
	};

	const clickedShowAdvancedBoard = (callVsPut) => {
		dispatch(
			setOptionChainAction({
				showAdvancedBoard: callVsPut,
				showHideStrike: false,
			})
		);

		ReactGA.event({
			category: 'ChainAction',
			action: "Click 'i' Button",
			label: `${callVsPut}`,
		});
	};

	const fetchOptionsDetail = (
		ticker,
		expiry,
		PC,
		strike,
		interval,
		date = ''
	) => {
		setAppState({ refreshingData: true });
		fetch(
			`${BaseURL}/api/optionsdetail?ticker=${ticker}&expiry=${expiry}&PC=${PC}&strike=${strike}&interval=${1}&date=${date}`
		)
			.then((result) => checkStatusFunc(result, setAppState))
			.then((result) => parseJSONFunc(result))
			.then((response) => {
				let data = jsonifyFunc(response);
				if (!data) return;
				setAppState({ modalDetail: data, refreshingData: false });
			});
		fetch(`${BaseURL}/api/stockSeries?ticker=${ticker}&date=${date}`)
			.then((result) => checkStatusFunc(result, setAppState))
			.then((result) => parseJSONFunc(result))
			.then((response) => {
				let data3 = jsonifyFunc(response);
				if (!data3) return;
				setAppState({ modalDetail3: data3 });
			});
	};

	const setWatchListData = async (data, index) => {
		let oldData = await watchListModalIndex;
		if (data) {
			if (oldData.includes(data)) {
				oldData = oldData.filter((dat) => dat !== data);
				setOptionChainState({ watchListModalIndex: oldData });
			} else {
				const newData = data;
				const concatedData = oldData.concat(newData);
				setOptionChainState({
					watchListModalIndex: concatedData,
				});
			}
		}
	};

	const setFavouriteList = (value) => setOptionChainState({ favioute: value });
	const setCheckPut = (data) => setOptionChainState({ checkPut: data });
	const setCheck = (data) => setOptionChainState({ check: data });

	useEffect(() => {
		setAppState({
			data,
			quoteInfo,
		});
		const updatedRows = makeReStructuredRows({
			optionChainState: optionChainReducer,
			appState: appReducer,
		});
		setState(updatedRows);
		setOptionChainState({
			noOMS: updatedRows.noOMS,
			callRows: updatedRows.callRows,
			putRows: updatedRows.putRows,
		});
	}, [data, quoteInfo, targetPrice, confidence]);

	useEffect(() => {
		const { warnings } = createWarningsListFunc({
			appState: appReducer,
			optionChainState: optionChainReducer,
			highestCallEdge: state.highestCallEdge,
			highestCallActual: state.highestCallActual,
			answerArrowPos: state.answerArrowPos,
			highestPutEdge: state.highestPutEdge,
			highestPutActual: state.highestPutActual,
			noOMS: state.noOMS,
		});

		setOptionChainState({ warnings });
		setWarningsState(warnings);
	}, [
		state,
		appReducer,
		optionChainReducer.callRows,
		optionChainReducer.putRows,
	]);

	const backExpirationSelectMobile = () =>
		setOptionChainState({ selectedExpration: false, showHideStrike: true });
	const openOICall = () =>
		ticker !== '' && localStorage.setItem('TYPE', 'calls');

	const { buyerSeller } = selections;
	const isXSmall = width < 426;

	const {
		callsAnswerArrowPos,
		putsAnswerArrowPos,
		currentPriceArrowPos,
		highestCallEdge,
		highestCallActual,
		highestPutEdge,
		highestPutActual,
		callRows,
		putRows,
	} = state;

	return showAdvancedBoard ? (
		<div
			style={
				!isMobile
					? {
							...styles.advancedWrapper,
							zoom: zoompercent,
					  }
					: { ...styles.advancedWrapperMobile }
			}
		>
			<AdvancedBoard
				rows={rows}
				changeBidAskMid={changeBidAskMid}
				strikeWidth={strikeWidth}
				selections={selections}
				targetPrice={targetPrice}
				answerArrowPos={
					showAdvancedBoard === 'Calls'
						? callsAnswerArrowPos
						: putsAnswerArrowPos
				}
				nearValue={nearValue}
				strikeValue={strikeValue}
				confidence={confidence}
				buyerSeller={buyerSeller}
				latestPrice={latestPrice}
				bidAskMid={bidAskMid}
				expirationOptions={expirationOptions}
				expirationDate={expiration}
				expiration={expiration}
				refreshingQuote={refreshingQuote}
				refreshingData={refreshingData}
				putVsCall={showAdvancedBoard}
				shadingActive={shadingActive}
				isChecked={hideShading}
				highestEdge={
					showAdvancedBoard === 'Calls' ? highestCallEdge : highestPutEdge
				}
				highestActual={
					showAdvancedBoard === 'Calls' ? highestCallActual : highestPutActual
				}
				hideShading={hideShading}
				changeExpiration={changeExpiration}
				currentPriceArrowPos={currentPriceArrowPos}
				warnings={warningsState.length > 0}
				toggleShading={toggleShading}
				isMobile={isMobile}
			/>
		</div>
	) : (
		<div
			style={
				isMobile
					? { ...styles.basicWrapperMobile }
					: {
							...styles.basicWrapper,
							zoom: zoompercent,
					  }
			}
		>
			{isMobile ? '' : <StrikeNear toggleShading={toggleShading} />}
			<div
				style={
					isMobile ? styles.basicBoardsWrapperMobile : styles.basicBoardsWrapper
				}
			>
				{callRows && (
					<BasicCallBoard
						accessLevel={accessLevel}
						setCheck={setCheck}
						check={check}
						watchListModalIndex={watchListModalIndex}
						setFavouriteList={setFavouriteList}
						favioute={favioute}
						setWatchListData={setWatchListData}
						width={width}
						isXSmall={isXSmall}
						rows={callRows}
						warnings={warningsState.length > 0}
						backFromAdvance={backFromAdvance}
						turnBackOff={() =>
							dispatch(setOptionChainAction({ backFromAdvance: false }))
						}
						ticker={localTicker}
						selectedDate={selectedDate}
						modalDate={modalDate}
						putRows={putRows}
						selections={selections}
						targetPrice={targetPrice}
						bidAskMid={bidAskMid}
						answerArrowPos={callsAnswerArrowPos}
						nearValue={nearValue}
						highestEdge={highestCallEdge}
						highestActual={highestCallActual}
						strikeValue={strikeValue}
						showAdvancedBoard={() => clickedShowAdvancedBoard('Calls')}
						backgoSelect={isMobile ? backExpirationSelectMobile : undefined}
						latestPrice={latestPrice}
						hideShading={hideShading}
						currentPriceArrowPos={currentPriceArrowPos}
						expirationOptions={expirationOptions}
						expiration={
							expiration ? moment(expiration).format('DD-MMM-YY') : ''
						}
						refreshingQuote={refreshingQuote}
						refreshingData={refreshingData}
						changeExpiration={changeExpiration}
						isMobile={isMobile}
						fetchOptionsDetail={(ticker, expiry, PC, strike, interval) =>
							fetchOptionsDetail(
								ticker,
								expiry,
								PC,
								strike,
								interval,
								modalDate
							)
						}
						optionsDetail={modalDetail}
						optionsDetail2={modalDetail2}
						optionsDetail3={modalDetail3}
						openOICall={openOICall}
					/>
				)}

				{putRows && (
					<BasicPutBoard
						accessLevel={accessLevel}
						setCheckPut={setCheckPut}
						checkPut={checkPut}
						setFavouriteList={setFavouriteList}
						favioute={favioute}
						watchListModalIndex={watchListModalIndex}
						setWatchListData={setWatchListData}
						selectedDate={selectedDate}
						modalDate={modalDate}
						rows={putRows}
						ticker={localTicker}
						selections={selections}
						answerArrowPos={putsAnswerArrowPos}
						highestEdge={highestPutEdge}
						highestActual={highestPutActual}
						targetPrice={targetPrice}
						bidAskMid={bidAskMid}
						showAdvancedBoard={() => clickedShowAdvancedBoard('Puts')}
						latestPrice={latestPrice}
						currentPriceArrowPos={currentPriceArrowPos}
						hideShading={hideShading}
						warnings={warningsState && warningsState.length > 0}
						toggleShading={toggleShading}
						expiration={
							expiration ? moment(expiration).format('DD-MMM-YY') : ''
						}
						isMobile={isMobile}
						fetchOptionsDetail={(ticker, expiry, PC, strike, interval) => {
							fetchOptionsDetail(
								ticker,
								expiry,
								PC,
								strike,
								interval,
								modalDate
							);
						}}
						optionsDetail={modalDetail}
						optionsDetail2={modalDetail2}
						optionsDetail3={modalDetail3}
					/>
				)}
			</div>
		</div>
	);
};

export default BoardViewSection;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BoardViewSection.jsx